import { RevenueShareConfiguration } from './revenue-share-configuration';

export class RevenueShareStatus {
    public isEnabled: boolean;
    public revenueShareConfiguration: RevenueShareConfiguration[];
    constructor(obj?: {
       isEnabled?: boolean;
       revenueShareConfiguration?: RevenueShareConfiguration[];
    }) {
        if (obj != null) {
            this.isEnabled = typeof obj.isEnabled === 'undefined' ? this.isEnabled : obj.isEnabled;
            this.revenueShareConfiguration = typeof obj.revenueShareConfiguration === 'undefined' ? this.revenueShareConfiguration : obj.revenueShareConfiguration;
        }
    }
}
